import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VAlert,{attrs:{"text":"","color":"info"}},[_c('h3',{staticClass:"text-h5"},[_vm._v(" お知らせ ")]),_vm._t("contents"),_c(VDivider,{staticClass:"my-4 info",staticStyle:{"opacity":"0.22"}}),_c(VRow,{attrs:{"align":"center","no-gutters":""}},[_vm._t("actions")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }